import React from 'react';
import ReactDOM from 'react-dom';

import './index.css';
import App from './screens/App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

